import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDataText = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 21,
	viewBox: "0 0 20 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M7.31874 15.0514V7.55449H4.82666V6.49365H10.9229V7.55449H8.43895V15.0514H7.31874ZM14.3731 15.2518C13.8208 15.2518 13.3763 15.08 13.0398 14.7366C12.7033 14.393 12.535 13.9407 12.535 13.3799V10.0449H11.41V9.07699H12.535V7.26449H13.6056V9.07699H15.1473V10.0449H13.6056V13.1764C13.6056 13.4958 13.6905 13.7539 13.8604 13.9505C14.0303 14.1471 14.2482 14.2453 14.5142 14.2453C14.6186 14.2453 14.7259 14.229 14.836 14.1964C14.9463 14.1639 15.0586 14.1166 15.1729 14.0547V15.1112C15.05 15.1653 14.9226 15.2023 14.7906 15.222C14.6587 15.2418 14.5195 15.2518 14.3731 15.2518Z",
		fill: "currentColor"
	})
});
export default SvgDataText;
